import React from 'react';

	const Logo = ({ width, height, showText = true, className = '', onClick }) => {
	// Default sizes based on showText
	const logoWidth = width || (showText ? 40 : 40);
	const logoHeight = height || (showText ? 40 : 40);
	const textSize = showText ? 'text-2xl' : 'text-lg';

	return (
		<div 
			className={`flex items-center space-x-3 ${className} ${onClick ? 'cursor-pointer' : ''}`}
			onClick={onClick}
		>
			<img
				src="/logo.png"
				alt="iVault Logo"
				width={logoWidth}
				height={logoHeight}
				className="flex-shrink-0"
				style={{ width: `${logoWidth}px`, height: `${logoHeight}px`, objectFit: 'contain', display: 'block' }}
			/>
			{showText && (
				<div className="flex flex-col justify-center items-start">
					<span className={`font-bold text-gray-900 ${textSize} leading-tight`}>
						iVault
					</span>
					<span className="text-xs text-gray-600 leading-tight">
						Your Digital Vault
					</span>
				</div>
			)}
		</div>
	);
};

export default Logo;



